import { Flex, Box, Tabs, TabList, Tab, TabPanels, TabPanel, VStack, Checkbox, Skeleton, CheckboxGroup, Divider, Text } from '@chakra-ui/react'
import { useGetAllLocationsQuery } from '../api/reportsApi'
import { TreeDevice } from '../pages/TreeDevice'
import { useGetUserDevicesQuery } from '../../locations/api/locationsApi'

export const TrendReportFilters = ({
  selectedLocations,
  selectedDevices,
  setSelectedLocations,
  setSelectedDevices
}) => {
  const { data: locations, isLoading } = useGetAllLocationsQuery({})
  const { data: userDevices, isLoading: isUserDevicesLoading } = useGetUserDevicesQuery({})
  const locationIds = locations?.results?.map((location) => location.id)

  return (
    <Flex w="full">
      <Box w="100%">
        <Tabs
          isFitted
          variant="unstyled"
          colorScheme="gray"
          onChange={(index) => {
            if (index === 0) setSelectedDevices([])
            if (index === 1) setSelectedLocations([])
          }}
        >
          <TabList bg="gray.100" p="1" borderRadius="full">
            <Tab
              _selected={{ bg: "white", color: "black", fontWeight: "bold" }}
              _hover={{ bg: "gray.200" }}
              borderRadius="full"
            >
              Locations
            </Tab>
            <Tab
              _selected={{ bg: "white", color: "black", fontWeight: "bold" }}
              _hover={{ bg: "gray.200" }}
              borderRadius="full"
            >
              Devices
            </Tab>
          </TabList>
          <TabPanels mt={4}>
            <TabPanel padding="0px">
              <VStack align="start" spacing={2}>
                <Flex justify="space-between" align="center" width="full">
                  <Text color="#484848" fontWeight={700} fontSize="14px" fontFamily="Inter">Select Location/s</Text>
                  <Checkbox
                    isChecked={selectedLocations?.length === locationIds?.length}
                    onChange={(e) =>
                      setSelectedLocations(e.target.checked ? locationIds : [])
                    }
                  >
                    Select all
                  </Checkbox>
                </Flex>
                {isLoading ? (
                  [...Array(4)].map((_, i) => (
                    <Skeleton key={i} height="32px" width="100%" borderRadius="md" />
                  ))
                ) : (
                  <CheckboxGroup
                    value={selectedLocations?.map(String)}
                    onChange={(value) => setSelectedLocations(value.map(Number))}
                  >
                    <Flex gap={3} wrap="wrap">
                      {locations?.results?.map((location) => (
                        <Checkbox
                          key={location.id}
                          value={location.id.toString()}
                          borderRadius="md"
                          px={3}
                          py={2}
                          bg="#F5F6F7"
                        >
                          {location.title}
                        </Checkbox>
                      ))}
                    </Flex>
                  </CheckboxGroup>
                )}
              </VStack>
              <Divider mt={4} />
            </TabPanel>
            <TabPanel padding="0px">
              <VStack align="start" spacing={2}>
                <Text color="#484848" fontWeight={700} fontSize="14px" fontFamily="Inter">Select Device/s</Text>
                {isUserDevicesLoading ? (
                  [...Array(4)].map((_, i) => (
                    <Skeleton key={i} height="32px" width="100%" borderRadius="md" />
                  ))
                ) : (
                  userDevices?.map((device) => (
                    <TreeDevice
                      key={device.id}
                      device={device}
                      selected={selectedDevices}
                      setSelected={setSelectedDevices}
                    />
                  ))
                )}
              </VStack>
              <Divider mt={4} />
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Box>
    </Flex>
  )
}
